import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Divider from "@material-ui/core/Divider";
import clientService from "./../../../services/MarketingService/ClientService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
const AddClient = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");

  const [age, setAge] = useState("");
  const [ville, setVille] = useState("");
  const [rue, setRue] = useState("");
  const [pays, setPays] = useState("");

  const [genre, setGenre] = useState("");
  const [genresData, setGenresData] = useState([]);

  const [erreur, setErreur] = useState(null);
  const [success, setSuccess] = useState(null);

  // useEffect(() => {
  //   if (success) {
  //     const timeoutId = setTimeout(() => {
  //       setSuccess(null);
  //     }, 2000); // 30 secondes en millisecondes
  //     return () => clearTimeout(timeoutId);
  //   }
  //   if (erreur) {
  //     const timeoutId = setTimeout(() => {
  //       setErreur(null);
  //     }, 2000); // 30 secondes en millisecondes
  //     return () => clearTimeout(timeoutId);
  //   }
  // }, [success, erreur]);

  useEffect(() => {
    AfficherListGenres();
  }, []);

  //methode pour afficher genres
  const AfficherListGenres = () => {
    try {
      clientService.AfficherListGenres().then((response) => {
        setGenresData(response.data.success);
      });
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };
  //methode d'ajout
  const ajouterClient = async (event) => {
    event.preventDefault();
    // Effectuer des vérifications sur les entrées (nom et numéro)
    if (!firstName || !lastName || !phoneNumber || !age || !ville || !pays) {
      // Vérifier si le nom et le numéro sont renseignés
      setErreur("Veuillez renseigner tous les champs.");
      return;
    }

    // Vérifier si le numéro est au format valide
    /*  const regex = /^\+(?:[0-9] ?){6,14}[0-9]$/;
    if (!regex.test(numero)) {
      setErreur("Le numéro doit être au format international valide.");
      return;
    }
 */
    // Si les entrées sont valides, créer un nouvel objet Client
    const nouveauClient = {
      firstName: firstName,
      lastName: lastName,
      genre: genre,
      phoneNumber: phoneNumber,
      age: age,
      ville: ville,
      rue: rue,
      pays: pays,
      email: email,
      idUserCreation: getCurrentUserId(),
    };
    // Appeler la méthode "ajouterClient()" de "clientService" en passant le nouvel objet Client comme argument
    try {
      clientService
        .ajouterClient(getCurrentUserId(), nouveauClient)
        .then((response) => {
          console.log(response.data.success); // Afficher la réponse (optionnel)
          // Réinitialiser les champs vide
          setFirstName("");
          setLastName("");
          setPhoneNumber("");
          setAge("");
          setVille("");
          setRue("");
          setPays("");
          setEmail("");
          setGenre([]);
          toastr.success("Ajout validée avec success !! ");

          // setSuccess("Ajout validée avec success !! ");
          setTimeout(() => {
            navigate(`/Client`);
          }, 2000);
        })
        .catch((error) => {
          console.log("error", error);
          toastr.error("Erreur lors de l'insertion.");
        });
    } catch (error) {
      console.log(error); // Afficher l'erreur (optionnel)
      toastr.error("Erreur lors de l'insertion.");
    }
  };
  // route
  const navigate = useNavigate();

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Client</h1>
            </div>
            <div className="col-sm-6">
              {/* <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="#">Marketing</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="#" onClick={() => navigate(-1)}>
                      Client
                    </a>
                  </li>

                  <li className="breadcrumb-item active">Creation</li>
                </ol> */}
            </div>
          </div>
        </div>
      </div>
      {/* /.content-header */}

      {/* content */}
      <section className="content">
        {/* container-fluid */}
        <div className="container-fluid">
          {/* notification d'erreur */}
          {erreur && (
            <div className="alert alert-danger" role="alert">
              {erreur}
            </div>
          )}
          {success && (
            <div className="alert alert-success" role="alert">
              {success}
            </div>
          )}

          <div className="card card-dark">
            <div className="card-header">
              <h3 className="card-title">Ajouter Client</h3>
            </div>
            <form onSubmit={ajouterClient}>
              <div className="card-body">
                <div className="form-group">
                  <div className="row">
                    <div className="col">
                      <label htmlFor="exampleInputEmail1">Prenom </label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Nom"
                        value={firstName}
                        onChange={(event) => setFirstName(event.target.value)}
                      />
                    </div>
                    <div className="col">
                      <label htmlFor="exampleInputEmail1">Nom</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Prenom"
                        value={lastName}
                        onChange={(event) => setLastName(event.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col">
                      <label htmlFor="type">Genre</label>
                      <select
                        className="custom-select"
                        id="type"
                        value={genre}
                        onChange={(e) => setGenre(e.target.value)}
                      >
                        <option value="">--</option>
                        {genresData.map((genre) => (
                          <option key={genre} value={genre}>
                            {genre}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col">
                      <label htmlFor="exampleInputEmail1">Email</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Email"
                        value={email}
                        onChange={(event) => setEmail(event.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col">
                      <label htmlFor="exampleInputEmail1">Numero</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Numero"
                        value={phoneNumber}
                        onChange={(event) => setPhoneNumber(event.target.value)}
                      />
                    </div>
                    <div className="col">
                      <label htmlFor="exampleInputEmail1">Age</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Age"
                        value={age}
                        onChange={(event) => setAge(event.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="exampleInputEmail1">Adresse</label>
                  <div className="row">
                    <div className="col">
                      <input
                        type="text"
                        class="form-control"
                        id="exampleInputEmail1"
                        placeholder="Rue"
                        value={rue}
                        onChange={(event) => setRue(event.target.value)}
                      />
                    </div>
                    <div className="col">
                      <input
                        type="text"
                        class="form-control"
                        id="exampleInputEmail1"
                        placeholder="Ville"
                        value={ville}
                        onChange={(event) => setVille(event.target.value)}
                      />
                    </div>
                    <div className="col">
                      <input
                        type="text"
                        class="form-control"
                        id="exampleInputEmail1"
                        placeholder="pays"
                        value={pays}
                        onChange={(event) => setPays(event.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-footer text-right">
                <button
                  type="button"
                  className="btn btn-secondary mr-2"
                  onClick={() => navigate("/Client")}
                >
                  Annuler
                </button>
                <button type="submit" className="btn btn-dark">
                  Ajouter
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AddClient;
